import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function TermsOfUse() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <>
      {/* Hero Section with Background Image */}
      <section
        className="bg-cover bg-center py-20 relative"
        style={{ backgroundImage: "url('/images/Terms-of-use-Slider.jpg')" }}
        data-aos="fade-up"
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 text-center text-white max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-center space-x-2 text-lg Bebas-neue mb-4" data-aos="fade-up" data-aos-delay="100">
            <span className="text-white">HOME</span>
            <span className="h-4 w-[1px] bg-gray-400 mx-1"></span>
            <span className="text-[#F47321]  uppercase">TERMS OF USE</span>
          </div>
          <h1 className="text-[75px] font-bold Bebas-neue" data-aos="fade-up" data-aos-delay="200">
            TERMS OF USE
          </h1>
        </div>
      </section>

      {/* Terms Content Section */}
      <section className="bg-white py-20" data-aos="fade-up">
        <div className="max-w-7xl mx-auto px-6">
                        <h1 className="!font-bold !text-4xl text-black  helvetica-neue uppercase text-center mb-5">TERMS OF USE</h1>

          <p className="text-black text-[18px] uppercase helvetica-neue !font-semibold mb-6" data-aos="fade-up" data-aos-delay="200">
            Effective as of 9 January 2023
          </p>
          <div className="text-[#234042] !text-[17px] helvetica-neue font-light space-y-6" data-aos="fade-up" data-aos-delay="300">
            <p>
              Welcome to LiveQR (the "Website"). By accessing or using the Website, you agree to be bound by these Terms of Use (these "Terms"). If you do not agree to all of the terms and conditions contained in these Terms, do not use the Website.
            </p>
            <p>
              We reserve the right to change these Terms at any time. Any changes will be effective immediately upon posting to the Website. Your continued use of the Website following the posting of changes will mean that you accept and agree to the changes. You should check these Terms periodically for changes.
            </p>
            <p>
              By accessing or using the Website, you represent and warrant that you have the right, authority, and capacity to enter into these Terms and to abide by all of the terms and conditions set forth herein.
            </p>
            <p>
              The Website is intended solely for Users who are 18 years of age or older. Any access to or use of the Website by anyone under 18 is strictly prohibited.
            </p>
            <p>
              LiveQR reserves the right to terminate or suspend your access to all or part of the Website, without notice, for any reason or no reason, including without limitation if LiveQR believes that you have violated or acted inconsistently with the letter or spirit of these Terms.
            </p>
            <p>
              You agree to indemnify and hold LiveQR and its affiliates, officers, agents, and other partners and employees, harmless from any loss, liability, claim, or demand, including reasonable attorneys' fees, made by any third party due to or arising out of your use of the Website, including any use by your employees, or your violation of these Terms.
            </p>
            <p>
              LiveQR makes no representations or warranties of any kind, express or implied, as to the operation of the Website or the information, content, materials, or products included on the Website. To the full extent permissible by applicable law, LiveQR disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose. LiveQR will not be liable for any damages of any kind arising from the use of the Website, including, but not limited to, direct, indirect, incidental, punitive, and consequential damages.
            </p>
            <p>
              These Terms constitute the entire agreement between you and LiveQR and govern your use of the Website, superseding any prior agreements between you and LiveQR. You also may be subject to additional terms and conditions that may apply when you use affiliate services, third-party content, or third-party software.
            </p>
            <p>
              The failure of LiveQR to exercise or enforce any right or provision of these Terms shall not constitute a waiver of such right or provision. If any provision of these Terms is found by a court of competent jurisdiction to be invalid, the parties nevertheless agree that the court should endeavor to give effect to the parties' intentions as reflected in the provision, and the other provisions of these Terms remain in full force and effect.
            </p>
            <p>
              You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to the use of the Website or these Terms must be filed within one (1) year after such claim or cause of action arose or be forever barred.
            </p>
            <p>
              The section titles in these Terms are for convenience only and have no legal or contractual effect.
            </p>
            <h2 className="text-[30px] !font-semibold text-black uppercase helvetica-neue  mt-10" data-aos="fade-up" data-aos-delay="400">
              LIMITATION OF LIABILITY
            </h2>
            <p>
              To the fullest extent permitted by law, LiveQR, its affiliates, officers, agents, and other partners and employees, shall not be liable for any loss or damage, direct or indirect, incidental, consequential, or punitive, resulting from or arising out of your use of the Website or the services provided on the Website, including but not limited to loss of profits, data, or other intangible losses.
            </p>
            <p>
              LiveQR shall not be responsible for any damages resulting from the loss of use, data, or profits, or from any unauthorized access to or alteration of your transmissions or data, or any other matter relating to the Website or the services provided on the Website.
            </p>
            <p>
              You acknowledge and agree that LiveQR has offered the Website and the services provided on the Website in reliance upon the limitations and exclusions of liability set forth in these Terms, and that the same form an essential basis of the bargain between you and LiveQR. You expressly agree that the limitations and exclusions of liability set forth in these Terms will survive, and continue to apply in the case of, a fundamental breach or breaches, the failure of essential purpose of contract, the failure of any exclusive remedy, or termination of these Terms.
            </p>
            <p>
              The limitations and exclusions of liability set forth in these Terms apply to the fullest extent permitted by law and shall survive any termination or expiration of these Terms or your use of the Website.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}